import { render, staticRenderFns } from "./StaffUpdateFormComponent.vue?vue&type=template&id=0d63b661&scoped=true"
import script from "./StaffUpdateFormComponent.vue?vue&type=script&lang=ts"
export * from "./StaffUpdateFormComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63b661",
  null
  
)

export default component.exports